import { removeClient } from "api";
import BottomSheet from "components/bottom-sheet";
import Button from "components/button";
import ErrorMessage from "components/error-message";
import Loader from "components/loader";
import NotFound from "components/not-found";
import { useState } from "react";
import styles from './styles.module.scss';
import { formatPhone } from "lib/utils";
import info from 'assets/images/info.svg';
import deleteIcon from 'assets/images/unbind.svg'
import useClients, { APIClient } from "api/hooks/use-clients";
import IconButton from "components/icon-button";

export const ClientsProfileTab: React.FC = () => {
    const [isRemovingClient, setIsRemovingClient] = useState(false);
    const [showRemoveBottomSheet, setShowRemoveBottomSheet] = useState<false | APIClient>(false);

    const { clients, error, isLoading, mutate } = useClients();

    const handleRemoveClient = async () => {
        if (showRemoveBottomSheet) {
            setIsRemovingClient(true);
            const res = await removeClient(showRemoveBottomSheet.id);
            setIsRemovingClient(false);

            if (res.result) {
                mutate();
            }

            setShowRemoveBottomSheet(false);
        }
    };

    const handleDissmissBottomSheet = () => setShowRemoveBottomSheet(false);
    return (
        <>
            <div>
                {isLoading ? (
                    <Loader />
                ) : error ? (
                    <ErrorMessage message={error} />
                ) : clients.length > 0 ? (
                    clients.map((client) => (
                        <div key={client.id} className={styles.client}>
                            <div className={styles.clientInfo}>
                                <div className={styles.clientContainer}>
                                    <div>
                                        <div className={styles.clientName}>{client.fullname.firstName} {client.fullname?.lastName}</div>
                                        <div className={styles.clientPhone}>{formatPhone(client.phone)}</div>
                                    </div>
                                    <IconButton icon={deleteIcon}
                                        onClick={() => setShowRemoveBottomSheet(client)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <NotFound />
                )}
            </div>

            <BottomSheet open={!!showRemoveBottomSheet} onDismiss={handleDissmissBottomSheet}>
                <div className={styles.dismissClientContainer}>
                    <img alt='Значок "i"' src={info} width={60} height={60} />
                    <div className={styles.dismissClientHeader}>Открепить клиента?</div>
                    <div className={styles.dismissClientQuestion}>
                        Открепляемый клиент <span className={styles.clientName}>{`${showRemoveBottomSheet && showRemoveBottomSheet.fullname.firstName
                            } `}</span>
                        не сможет взаимодействовать с Вами в системе
                    </div>
                </div>

                <Button label='Открепить' loading={isRemovingClient} onClick={handleRemoveClient} />
                <Button label='Нет, я передумал' variant='transparent' onClick={handleDissmissBottomSheet} />
            </BottomSheet>
        </>
    );
};